<div class="offcanvas-header justify-content-between shadow">
  <h4 id="multiSimOffCanvasLabel" class="offcanvas-title mb-0">
    {{
      offcanvas_asset && isDeviceAsset(offcanvas_asset.multi_sim_type)
        ? ('device_details' | translate)
        : ('line_details' | translate)
    }}
  </h4>
  <button
    type="button"
    class="btn btn-outline-secondary"
    data-bs-dismiss="offcanvas"
    (click)="offcanvas.dismiss('Close')"
  >
    {{ 'close' | translate }}
  </button>
</div>
<div class="offcanvas-body pt-4">
  <div class="card">
    <div class="card-header d-flex align-items-center">
      <h4 class="my-2 me-2">
        {{ offCanvasAssetTitle() }}
      </h4>
      @if (offcanvas_asset && isLineAsset(offcanvas_asset.multi_sim_type)) {
        <ts-status-badge
          [status]="(offcanvas_asset?.line)!.status"
          [status_display_name]="(offcanvas_asset?.line)!.status_display_name"
        />
      }
      @if (offcanvas_asset && isLineAsset(offcanvas_asset.multi_sim_type)) {
        <ts-eligibility-badge class="ms-2" [line]="offcanvas_asset.line" />
      }
    </div>
    <div class="card-body card-items card-items-md my-4">
      <ts-dashboard-asset
        class="d-contents"
        [asset]="offcanvas_asset!"
        [plan]="offcanvas_asset?.line?.plan"
        [is_detail]="true"
        [is_offcanvas]="true"
        [offcanvas_type]="offcanvas_asset?.multi_sim_type"
      ></ts-dashboard-asset>

      @if (offcanvas_asset?.multi_sim_type === multi_sim_types[2]) {
        <div>
          <hr class="mx-3" />
          <ts-asset-card
            [asset]="offcanvas_asset"
            [asset_fields]="['imei_associated', 'sim_number_label']"
            [is_offcanvas]="true"
          ></ts-asset-card>
        </div>
      }

      @if (offcanvas_asset?.multi_sim_type === multi_sim_types[0]) {
        <div>
          @if (offcanvas_asset?.line) {
            <div>
              <hr class="mx-3" />
              <ts-asset-card
                [asset]="offcanvas_asset"
                [additional_asset]="offcanvas_asset!.line"
                [additional_asset_type]="multi_sim_types[4]"
                [asset_fields]="['imei_associated', 'sim_number_label']"
                [is_offcanvas]="true"
              ></ts-asset-card>
            </div>
          }
          @for (additional_asset of offcanvas_asset?.additional_lines; track additional_asset) {
            <div class="additional-assets_details">
              <hr class="mx-3" />
              <ts-asset-card
                [asset]="offcanvas_asset"
                [additional_asset]="additional_asset"
                [additional_asset_type]="multi_sim_types[4]"
                [asset_fields]="['imei_associated', 'sim_number_label']"
                [is_offcanvas]="true"
              ></ts-asset-card>
            </div>
          }
        </div>
      }

      @if ([multi_sim_types[1], multi_sim_types[6]].includes(offcanvas_asset!.multi_sim_type)) {
        <div class="row flex-column g-0 additional-assets">
          @if (offcanvas_asset?.device) {
            <div>
              <hr class="mx-3" />
              <ts-asset-card
                [asset]="offcanvas_asset"
                [additional_asset]="offcanvas_asset!.device"
                [additional_asset_type]="multi_sim_types[3]"
                [asset_fields]="
                  hasRefDevice(offcanvas_asset!.device) && !hasDeviceId(offcanvas_asset!.device)
                    ? ['sim_number_label']
                    : ['imei', 'imei2', 'serial_number', 'imei_associated', 'sim_number_label']
                "
                [is_offcanvas]="true"
              ></ts-asset-card>
            </div>
          }
          @for (additional_asset of offcanvas_asset?.additional_devices; track additional_asset) {
            <div class="col additional-assets_details">
              <hr class="mx-3" />
              <ts-asset-card
                [asset]="offcanvas_asset"
                [additional_asset]="additional_asset"
                [additional_asset_type]="multi_sim_types[3]"
                [asset_fields]="
                  hasRefDevice(additional_asset) && !hasDeviceId(additional_asset)
                    ? ['sim_number_label']
                    : ['imei', 'imei2', 'serial_number', 'imei_associated', 'sim_number_label']
                "
                [is_offcanvas]="true"
              ></ts-asset-card>
            </div>
          }
        </div>
      }

      @if (offcanvas_asset?.multi_sim_type === multi_sim_types[5]) {
        <div>
          <hr class="mx-3" />
          <ts-asset-card
            [asset]="offcanvas_asset"
            [additional_asset_type]="multi_sim_types[5]"
            [asset_fields]="['sim_number_label']"
            [is_offcanvas]="true"
          ></ts-asset-card>
        </div>
      }
    </div>
  </div>
</div>
